import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, TextField, Button, Stack, Chip, Alert } from '@mui/material';
import { useAuth } from '../contexts/AuthContext';
import { useNotifications } from '../contexts/NotificationContext';
import modelsService from '../services/modelsService';

const NewModelPage = () => {
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [tags, setTags] = useState([]);
  const [tagInput, setTagInput] = useState('');
  const [prompt, setPrompt] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const { currentUser } = useAuth();
  const { addSystemNotification } = useNotifications();

  const handleAddTag = () => {
    if (tagInput && !tags.includes(tagInput)) {
      setTags([...tags, tagInput]);
      setTagInput('');
    }
  };

  const handleDeleteTag = (tagToDelete) => {
    setTags(tags.filter((tag) => tag !== tagToDelete));
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleAddTag();
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!currentUser) {
      setError('Utilisateur non authentifié');
      return;
    }

    if (!title.trim() || !prompt.trim()) {
      setError('Le titre et le prompt sont requis');
      return;
    }

    setIsSubmitting(true);
    setError(null);

    try {
      await modelsService.createModel({
        title: title.trim(),
        description: description.trim(),
        tags,
        prompt: prompt.trim()
      }, currentUser.uid);
      
      navigate('/models?filter=mine');
    } catch (error) {
      addSystemNotification('Erreur lors de la création du modèle:', 'error');
      setError('Erreur lors de la création du modèle');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Box sx={{ maxWidth: 600, mx: 'auto', py: 4 }}>
      <Typography variant="h4" fontWeight={700} mb={3}>Nouveau modèle</Typography>
      <form onSubmit={handleSubmit}>
        <Stack spacing={3}>
          <TextField label="Titre" value={title} onChange={e => setTitle(e.target.value)} required fullWidth />
          <TextField label="Description" value={description} onChange={e => setDescription(e.target.value)} multiline minRows={2} fullWidth />
          <Box>
            <TextField label="Ajouter un tag" value={tagInput} onChange={e => setTagInput(e.target.value)} onKeyDown={handleKeyPress} sx={{ mr: 1 }} />
            <Button onClick={handleAddTag} variant="outlined">Ajouter</Button>
            <Stack direction="row" spacing={1} sx={{ mt: 1, flexWrap: 'wrap' }}>
              {tags.map((tag, idx) => (
                <Chip key={idx} label={tag} onDelete={() => handleDeleteTag(tag)} color="primary" />
              ))}
            </Stack>
          </Box>
          <TextField label="Prompt" value={prompt} onChange={e => setPrompt(e.target.value)} multiline minRows={2} fullWidth />
          <Button type="submit" variant="contained" size="large" disabled={isSubmitting}>Créer le modèle</Button>
          {error && <Alert severity="error">{error}</Alert>}
        </Stack>
      </form>
    </Box>
  );
};

export default NewModelPage; 